/**
 *
 * This is only in @limitless/navigation because the canvas-compress library requires the window object.
 *
 * Next.js apps don't have a window object and don't require react navigation (also requires window object)
 *
 */
import CanvasCompress from "canvas-compress";
//Limitless imports
import { log as pilog } from "@limitless/common/utils";
export const getCompressCanvasData = (canvas, callback) => {
  const pictureCompressor = new CanvasCompress({
    type: CanvasCompress.MIME.PNG,
    width: 400,
    height: 400
  });
  const thumbnailCompressor = new CanvasCompress({
    type: CanvasCompress.MIME.PNG,
    width: 50,
    height: 50
  });
  getCompressedPictureFromCanvas(canvas, pictureCompressor, picture => {
    getCompressedPictureFromCanvas(canvas, thumbnailCompressor, thumbnail => {
      callback({
        picture,
        thumbnail
      });
    });
  });
};
const getCompressedPictureFromCanvas = (canvas, compressor, callback) => {
  const log = pilog.getLogger("ProfilePictureHelper getCompressedPictureFromCanvas");

  //convert the canvas to a blob, with that blob, run it through a compression tool and then covert to base64
  //compression saves about 70% file size
  try {
    canvas.toBlob(blob => {
      compressor.process(blob).then(result => {
        const reader = new FileReader();
        reader.readAsDataURL(result.result.blob);
        reader.onloadend = () => {
          const base64data = reader.result;
          callback(base64data.replace("data:image/png;base64,", ""));
        };
      }).catch(error => {
        log.error("Error converting canvas to base64 ", error);
        callback("");
      });
    });
  } catch (error) {
    log.error("Error converting canvas to base64 ", error);
    callback("");
  }
};